/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { Link, NavLink } from 'react-router-dom';

import { RouteAndChildrenProps } from '../@jms-react/types/aux-props';

export function AsideAdmin(props: RouteAndChildrenProps) {
  const linkOrderState = '전체';
  const orderStateParam = {
    linkOrderState,
  };
  const bookIs = 'all';
  const orderIs = 'all';

  return (
    <div className="container admin">
      <aside>
        <div className="logo">
          <Link to="/admin" />
        </div>
        <svg className="toggle-menu" viewBox="0 0 100 100" width="80">
          <path d="m 30,33 h 40 c 0,0 9.044436,-0.654587 9.044436,-8.508902 0,-7.854315 -8.024349,-11.958003 -14.89975,-10.85914 -6.875401,1.098863 -13.637059,4.171617 -13.637059,16.368042 v 40" />
          <path d="m 30,50 h 40" />
          <path d="m 30,67 h 40 c 12.796276,0 15.357889,-11.717785 15.357889,-26.851538 0,-15.133752 -4.786586,-27.274118 -16.667516,-27.274118 -11.88093,0 -18.499247,6.994427 -18.435284,17.125656 l 0.252538,40" />
        </svg>
        <ul className="menu">
          <li>
            <div className="main-menu">
              <span>도서 관리</span>
              <svg
                className="arrow"
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
              >
                <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
              </svg>
            </div>
            <ul className="sub-menu">
              <li>
                <NavLink activeClassName="active" to="/admin/book/new-book">
                  신규 도서 등록
                </NavLink>
              </li>
              <li>
                <NavLink activeClassName="active" to={{ pathname: `/admin/book/list/${bookIs}` }}>
                  도서 조회/수정
                </NavLink>
              </li>
              <li>
                <NavLink activeClassName="active" to="/admin/book/categories">
                  카테고리 설정
                </NavLink>
              </li>
            </ul>
          </li>
          <li>
            <div className="main-menu">
              <span>판매 관리</span>
              <svg
                className="arrow"
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
              >
                <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
              </svg>
            </div>
            <ul className="sub-menu">
              <li>
                <NavLink
                  activeClassName="active"
                  to={{ pathname: `/admin/sale/order-list/${orderIs}` }}
                >
                  주문 조회
                </NavLink>
              </li>
              {/* <li>
                <NavLink activeClassName="active" to="/admin/sale/group-buying">
                  공동구매 현황
                </NavLink>
              </li> */}
              <li>
                <NavLink activeClassName="active" to="/admin/sale/shipping">
                  배송정보 관리
                </NavLink>
              </li>
            </ul>
          </li>
          <li>
            <div className="main-menu">
              <span>회원 관리</span>
              <svg
                className="arrow"
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
              >
                <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
              </svg>
            </div>
            <ul className="sub-menu">
              <li>
                <NavLink activeClassName="active" to="/admin/member/entire">
                  전체 회원 현황
                </NavLink>
              </li>
              <li>
                <NavLink activeClassName="active" to="/admin/member/normal">
                  일반 회원 현황
                </NavLink>
              </li>
              <li>
                <NavLink activeClassName="active" to="/admin/member/professor">
                  교수 회원 현황
                </NavLink>
              </li>
              <li>
                <NavLink activeClassName="active" to="/admin/member/author">
                  저자 회원 현황
                </NavLink>
              </li>
              <li>
                <NavLink activeClassName="active" to="/admin/member/admin">
                  관리자 현황
                </NavLink>
              </li>
            </ul>
          </li>
          <li>
            <div className="main-menu">
              <span>게시판 관리</span>
              <svg
                className="arrow"
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
              >
                <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
              </svg>
            </div>
            <ul className="sub-menu">
              <li>
                <NavLink activeClassName="active" to="/admin/board/notice">
                  공지사항
                </NavLink>
              </li>
              <li>
                <NavLink activeClassName="active" to="/admin/board/errata">
                  정오표
                </NavLink>
              </li>
              <li>
                <NavLink activeClassName="active" to="/admin/board/lecture-lib">
                  강의자료실
                </NavLink>
              </li>
              <li>
                <NavLink activeClassName="active" to="/admin/board/lib">
                  일반자료실
                </NavLink>
              </li>
              <li>
                <NavLink activeClassName="active" to="/admin/board/sample-book">
                  견본도서요청
                </NavLink>
              </li>
              <li>
                <NavLink activeClassName="active" to="/admin/board/publish">
                  출판문의
                </NavLink>
              </li>
              {/* <li>
                <NavLink activeClassName="active" to="/admin/board/qna">
                  질의응답
                </NavLink>
              </li> */}
            </ul>
          </li>
          <li>
            <div className="main-menu">
              <span>광고 관리</span>
              <svg
                className="arrow"
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
              >
                <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
              </svg>
            </div>
            <ul className="sub-menu">
              <li>
                <NavLink activeClassName="active" to="/admin/banner-logo/banner">
                  협력사 / 교육기관 배너
                </NavLink>
              </li>
              <li>
                <NavLink activeClassName="active" to="/admin/banner-logo/advertisement">
                  광고 상세설정
                </NavLink>
              </li>
            </ul>
          </li>
          <li>
            <div className="main-menu">
              <span>서점 관리</span>
              <svg
                className="arrow"
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
              >
                <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
              </svg>
            </div>
            <ul className="sub-menu">
              <li>
                <NavLink activeClassName="active" to="/admin/store/online">
                  온라인 서점
                </NavLink>
              </li>
              <li>
                <NavLink activeClassName="active" to="/admin/store/offline">
                  오프라인 서점{' '}
                </NavLink>
              </li>
            </ul>
          </li>
          <li>
            <div className="main-menu">
              <span>기타</span>
              <svg
                className="arrow"
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
              >
                <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
              </svg>
            </div>
            <ul className="sub-menu">
              <li>
                <NavLink activeClassName="active" to="/admin/etc/refund">
                  반품환불정보
                </NavLink>
              </li>
            </ul>
          </li>
          <li>
            <div className="main-menu">
              <span>통계관리</span>
              <svg
                className="arrow"
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
              >
                <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
              </svg>
            </div>
            <ul className="sub-menu">
              <li>
                <NavLink activeClassName="active" to="/admin/statistics/by-book">
                  도서별 판매통계
                </NavLink>
              </li>
              <li>
                <NavLink activeClassName="active" to="/admin/statistics/by-member">
                  회원별 판매통계
                </NavLink>
              </li>
            </ul>
          </li>
          <li>
            <div className="main-menu">
              <span>나가기</span>
              <svg
                className="arrow"
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
              >
                <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
              </svg>
            </div>
            <ul className="sub-menu">
              <li>
                <NavLink activeClassName="active" to="/index">
                  홈화면
                </NavLink>
              </li>
            </ul>
          </li>
        </ul>
      </aside>
      {props.children}
    </div>
  );
}
